export default {
  "content": "<path d=\"M5 16a2 2 0 110 4 2 2 0 010-4zM21 19H9v-2h12v2zM21 13H9v-2h12v2zM5 4a2 2 0 110 4 2 2 0 010-4zM21 7H9V5h12v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};